import { Tooltip } from 'bootstrap'

let delegatedTooltip: Tooltip | null = null

export function initDelegatedTooltips() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null
  if (delegatedTooltip) return delegatedTooltip

  delegatedTooltip = new Tooltip(document.body, {
    selector: '[data-bs-toggle="tooltip"]',
    container: document.body,
    boundary: 'clippingParents',
    trigger: 'hover focus',
    placement: 'top',
  })

  return delegatedTooltip
}

export function disposeDelegatedTooltips() {
  delegatedTooltip?.dispose()
  delegatedTooltip = null
}
